"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
/** @jsx jsx */
var react_1 = require("@emotion/react");
var variables_1 = require("../../../../style/variables");
var styles = {
    wrapper: react_1.css({
        cursor: 'pointer',
        color: "var(" + variables_1.RootColor.Gray.LIGHT_1 + ")",
        '&:hover': {
            color: "var(" + variables_1.RootColor.Gray.DEFAULT + ")",
        },
        flexShrink: 0,
    }),
    active: react_1.css({
        color: "var(" + variables_1.RootColor.Gray.DARK_4 + ")",
    }),
};
var SortIcon = function (_a) {
    var activeSortOrder = _a.activeSortOrder, props = __rest(_a, ["activeSortOrder"]);
    return (react_1.jsx("svg", __assign({ width: "16", css: styles.wrapper, height: "21", viewBox: "0 0 16 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.jsx("path", { d: "M11 5V16M11 16L8.5 13.25M11 16L13.5 13.25", css: [activeSortOrder === 'DESC' ? styles.active : undefined], strokeWidth: "1.33", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.jsx("path", { stroke: "currentColor", d: "M4.99998 16V5M4.99998 5L2.49998 7.75M4.99998 5L7.49998 7.75", css: [activeSortOrder === 'ASC' ? styles.active : undefined], strokeWidth: "1.33", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = SortIcon;
